import { endpoints } from 'api/endpoints'
import { GetOneResponse } from 'interfaces/api.interfaces'
import { Constraints, HierarchyLevels, TargetVariables } from 'interfaces/api/promoSettings.interfaces'
import { axios } from 'modules/axios'

const getAllConstraints = async (): GetOneResponse<Constraints> => {
  const { data: response } = await axios.request<Constraints>({
    method: 'GET',
    url: endpoints.promoSettings.getAllConstraints(),
  })
  return response
}

const getAllHierarchyLevels = async (): GetOneResponse<HierarchyLevels> => {
  const { data: response } = await axios.request<HierarchyLevels>({
    method: 'GET',
    url: endpoints.promoSettings.getAllHierarchyLevels(),
  })
  return response
}

const getAllTargetVariables = async (): GetOneResponse<TargetVariables> => {
  const { data: response } = await axios.request<TargetVariables>({
    method: 'GET',
    url: endpoints.promoSettings.getAllTargetVariables(),
  })
  return response
}

const createAllConstraints = (data: Constraints): Promise<void> =>
  axios.request({
    method: 'POST',
    url: endpoints.promoSettings.createAllConstraints(),
    data,
  })

const createAllHierarchyLevels = (data: HierarchyLevels): Promise<void> =>
  axios.request({
    method: 'POST',
    url: endpoints.promoSettings.createAllHierarchyLevels(),
    data,
  })

const createAllTargetVariables = (data: TargetVariables): Promise<void> =>
  axios.request({
    method: 'POST',
    url: endpoints.promoSettings.createAllTargetVariables(),
    data,
  })

const update = <T>(id: string, data: T): Promise<void> =>
  axios.request({
    method: 'PATCH',
    url: endpoints.promoSettings.update(id),
    data,
  })

const remove = (id: string): Promise<void> =>
  axios.request({
    method: 'DELETE',
    url: endpoints.promoSettings.remove(id),
  })

const updateConstraint: <ConstraintData>(id: string, data: ConstraintData) => Promise<void> = update
const updateHierarchyLevel: <HierarchyLevelData>(id: string, data: HierarchyLevelData) => Promise<void> = update
const updateTargetVariable: <TargetVariableData>(id: string, data: TargetVariableData) => Promise<void> = update

export const promoSettingsApi = {
  createAllConstraints,
  createAllHierarchyLevels,
  createAllTargetVariables,
  getAllConstraints,
  getAllHierarchyLevels,
  getAllTargetVariables,
  updateConstraint,
  updateHierarchyLevel,
  updateTargetVariable,
  remove,
}
